export const validatePhoneNumber = (phone: string) => {
  const phoneRegEx = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/

  if (phoneRegEx.test(phone)) {
    return true
  }
  return false
}
